var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmaIcon = function SvgEmaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B75332",
    fillRule: "evenodd",
    d: "M3.249 2.429A1.93 1.93 0 0 1 5.178.5h7.714a1.93 1.93 0 0 1 1.928 1.929v1.073h2.17a.964.964 0 0 1 0 1.929h-2.17v3.105h2.17a.964.964 0 0 1 0 1.928h-2.17v3.105h2.17a.965.965 0 0 1 0 1.929h-2.17v1.073a1.93 1.93 0 0 1-1.928 1.929H5.178a1.93 1.93 0 0 1-1.929-1.929v-1.073H1.08a.964.964 0 1 1 0-1.929h2.169v-3.105H1.08a.964.964 0 0 1 0-1.928h2.169V5.43H1.08a.964.964 0 1 1 0-1.929h2.169zm6.233 12.448a.804.804 0 1 0 0 1.607h2.572a.804.804 0 0 0 0-1.607z",
    clipRule: "evenodd"
  })));
};
export { SvgEmaIcon as ReactComponent };
export default "/_next/static/media/static/media/EMA Icon.1265154bc84297a087a60ea175ed5871svg";